import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { AppSource, SessionService, Enviroment, LogEntry, LogLevel, LogModel, LogPublisher } from "@nstep-common/core";
import { getCaller } from "@nstep-common/utils";

import { catchError, EMPTY, Observable, of } from "rxjs";

export class LogApi extends LogPublisher {
	private apiUrl: string;

	constructor(private httpClient: HttpClient,
		private sessionService: SessionService,
		private environment: Enviroment) {
		super();

		const hostUrl = `${window.location.protocol}//${window.location.host}`;

		this.apiUrl = this.environment.apiUrl.startsWith('http')
			? this.environment.apiUrl
			: `${hostUrl}${this.environment.apiUrl}`;
	}

	log(record: LogEntry): Observable<any> {
		if (!record.message?.trim()) {
			return of();
		}

		// We do this to prevent requests when the server is disconnected
		const containsOfflineError = record.extraInfo.some(detail =>
			(detail instanceof HttpErrorResponse && detail.status === 0) ||
			(detail?.resp instanceof HttpErrorResponse && detail.resp.status === 0)
		);

		if (containsOfflineError) {
			return of();
		}

		const model = new LogModel();

		model.methodName = getCaller(5);
		model.parameters = record.buildLogString();
		model.deviceIdentifier = record.source === AppSource.Public ? 'NSTEP Public Web App' : 'NSTEP Internal Web App';
		model.timeStamp = record.entryDate;
		model.isError = record.level === LogLevel.Error;

		// We do this to prevent requests when user is not logged in
		if (this.sessionService.hasAccessExpired()) {
			return of();
		}

		return this.httpClient
			.post<LogModel>(`${this.apiUrl}/logs`, model, { withCredentials: true })
			.pipe(catchError(() => EMPTY));
	}
}